import { render } from "./Reset_Password.vue?vue&type=template&id=698a960b&scoped=true"
import script from "./Reset_Password.vue?vue&type=script&lang=js"
export * from "./Reset_Password.vue?vue&type=script&lang=js"

import "./Reset_Password.vue?vue&type=style&index=0&id=698a960b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698a960b"]])

export default __exports__